<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onBeforeUnmount, onMounted, ref, type ComponentPublicInstance } from 'vue';

import { useScoutPanelStore } from '@/stores/ui/ScoutPanelStore.ts';
import { useChatStore } from '@/stores/v2/ChatStore.ts';

import AScout from '@/components/atoms/AScout.vue';

const props = defineProps({
  inDialog: {
    type: Boolean,
    default: false,
  },
});

const scoutPanelStore = useScoutPanelStore();
const { isOpen, answerReady } = storeToRefs(scoutPanelStore);
const { isInvestigating } = storeToRefs(useChatStore());

const buttonRef = ref<ComponentPublicInstance | null>(null);
let anchorEl: HTMLElement | null = null;

onMounted(() => {
  const el = buttonRef.value?.$el;
  if (!(el instanceof HTMLElement)) return;
  anchorEl = el;
  scoutPanelStore.registerAnchor(el, props.inDialog);
});

onBeforeUnmount(() => {
  if (anchorEl) scoutPanelStore.releaseAnchor(anchorEl);
});
</script>

<template>
  <AScout
    ref="buttonRef"
    :active="isOpen"
    :busy="isInvestigating && !isOpen"
    :ready="answerReady"
    @click="scoutPanelStore.toggle()"
  />
</template>
